import { PRICE_RANGE } from 'Pods/SearchPage/Store/constants'

export const priceRangeOptions = [
  {
    value: PRICE_RANGE.FREE,
    label: 'Free',
  },
  {
    value: PRICE_RANGE.RANGE_2_10,
    label: '$2 - $10',
  },
  {
    value: PRICE_RANGE.RANGE_10_20,
    label: '$10 - $20',
  },
  {
    value: PRICE_RANGE.RANGE_20_50,
    label: '$20 - $50',
  },
  {
    value: PRICE_RANGE.RANGE_50_100,
    label: '$50 - $100',
  },
  {
    value: PRICE_RANGE.MORE_THAN_100,
    label: '$100+',
  },
]
